import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getContactContent = (store) => {
    let contact = {
        contact_status: 'INITIAL',
    };
    contact.contact_status = 'LOADING';
    store.setState({ contact });
    try {
        //Contact page query
        const ContactQuery = Stack.ContentType('page_contact_us').Query();
        ContactQuery.includeReference([
            'contact_us_image', 
             'contacts'])
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const contactData = result[0];
                    const isContentEmpty = contactData.length == 0;
                    contact = isContentEmpty ? contact : contactData[0];
                    contact.contact_status = isContentEmpty
                        ? 'EMPTY'
                        : 'SUCCESS';
                    store.setState({
                        contact,
                    });
                },
                function error(err) {
                    const isError404 =
                        error.response && error.response.status === 404;
                    contact.contact_status = isError404 ? 'NOT_FOUND' : 'ERROR';
                    store.setState({ contact });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
